const MAX_SIZE = String(Number.MAX_SAFE_INTEGER).length - 1;

export const getAssetTrackingId = () => {
  const randomId = Math.random() * (10 ** MAX_SIZE);

  return String(Math.ceil(randomId));
}